import type { CareKind } from '../../shared/api/types';

export const CARE_LABEL: Record<CareKind, string> = {
  meal: 'Comió',
  nap: 'Durmió',
  diaper: 'Cambio de pañal',
  note: 'Nota',
  incident: 'Incidente',
  call_guardian: 'Llamar al tutor',
};

/** "1 año 3 meses", "8 meses". */
export function formatAge(months: number | null): string {
  if (months === null) return '';
  const years = Math.floor(months / 12);
  const rest = months % 12;
  const y = years === 0 ? '' : years === 1 ? '1 año' : `${years} años`;
  const m = rest === 0 && years > 0 ? '' : rest === 1 ? '1 mes' : `${rest} meses`;
  return [y, m].filter(Boolean).join(' ');
}

export function ageRange(min: number | null, max: number | null): string {
  if (min === null && max === null) return 'Todas las edades';
  if (min !== null && max !== null) return `${formatAge(min) || '0 meses'} a ${formatAge(max)}`;
  return min !== null ? `Desde ${formatAge(min)}` : `Hasta ${formatAge(max)}`;
}

export const clock = (iso: string) => new Date(iso).toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' });
